import { IFilter } from "app/components/visualizations/PeerGroups/lib/http";
import * as React from "react";

interface ITabHeaderProps {
  filters: IFilter;
  label: string;
}

export class TabHeader extends React.Component<ITabHeaderProps, {}> {
  getHeaderText() {
    const { assetLevel, assetName } = this.props.filters;
    const prefixText =
      assetLevel === 0 ? ": All Foundations" : `: ${assetName} Peer Group`;
    return this.props.label + prefixText;
  }

  render() {
    return <header className="homeHeader">{this.getHeaderText()}</header>;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tabs/header/index.tsx